(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const body = document.getElementById('cart-drawer-body');
    const footer = document.getElementById('cart-drawer-footer');
    const status = document.getElementById('cart-drawer-status');
    const closeBtn = drawer.querySelector('[data-drawer-close]');

    // ── Open / Close with slide animation ──

    function open() {
      drawer.showModal();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          drawer.classList.add('cart-drawer--open');
        });
      });
    }

    function close() {
      drawer.classList.remove('cart-drawer--open');
      drawer.addEventListener('transitionend', function onEnd(e) {
        if (e.target !== drawer) return;
        drawer.removeEventListener('transitionend', onEnd);
        drawer.close();
      }, { once: true });
      // Fallback if transition doesn't fire (prefers-reduced-motion)
      setTimeout(() => { if (drawer.open) drawer.close(); }, 350);
    }

    closeBtn.addEventListener('click', close);

    // Close on backdrop click
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) close();
    });

    // Close on Esc (native dialog handles this, but we need the animation)
    drawer.addEventListener('cancel', (e) => {
      e.preventDefault();
      close();
    });

    // ── Header cart icon → open drawer (unless on /cart page) ──

    document.addEventListener('click', (e) => {
      const cartLink = e.target.closest('.header__cart');
      if (!cartLink) return;
      if (window.location.pathname === '/cart') return; // let it navigate
      e.preventDefault();
      refreshDrawer().then(open);
    });

    // ── Listen for cart:added event from product page ──

    window.addEventListener('cart:added', () => {
      refreshDrawer().then(open);
    });

    // ── Section Rendering API refresh ──

    function refreshDrawer() {
      return fetch('/?sections=cart-drawer')
        .then(r => r.json())
        .then(data => {
          const html = data['cart-drawer'];
          if (!html) throw new Error('Section empty');
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newBody = doc.getElementById('cart-drawer-body');
          const newFooter = doc.getElementById('cart-drawer-footer');
          if (newBody) body.innerHTML = newBody.innerHTML;
          if (newFooter) footer.innerHTML = newFooter.innerHTML;
          footer.className = newFooter ? newFooter.className : footer.className;
          updateHeaderBadge();
        })
        .catch(() => {
          window.location = '/cart';
        });
    }

    // ── Update header badge count ──

    function updateHeaderBadge() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const badge = document.querySelector('.header__cart-count');
          if (cart.item_count > 0) {
            if (badge) {
              badge.textContent = cart.item_count;
            } else {
              const span = document.createElement('span');
              span.className = 'header__cart-count';
              span.textContent = cart.item_count;
              document.querySelector('.header__cart').appendChild(span);
            }
          } else if (badge) {
            badge.remove();
          }
        });
    }

    // ── Quantity change / remove via change.js ──

    drawer.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('[data-drawer-qty-action]');
      const removeBtn = e.target.closest('[data-drawer-remove]');

      if (qtyBtn) {
        const item = qtyBtn.closest('[data-drawer-item]');
        const line = parseInt(item.dataset.line);
        const qtyEl = item.querySelector('.drawer-item__qty-value');
        let qty = parseInt(qtyEl.textContent);
        if (qtyBtn.dataset.drawerQtyAction === 'increase') qty++;
        else if (qtyBtn.dataset.drawerQtyAction === 'decrease') qty--;
        changeQuantity(line, Math.max(0, qty));
      }

      if (removeBtn) {
        const item = removeBtn.closest('[data-drawer-item]');
        const line = parseInt(item.dataset.line);
        changeQuantity(line, 0);
      }
    });

    function changeQuantity(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(r => r.json())
        .then(() => {
          if (status) status.textContent = quantity === 0
            ? drawer.dataset.msgRemoved
            : drawer.dataset.msgUpdated;
          refreshDrawer().then(() => {
            // Close drawer if cart is now empty
            fetch('/cart.js').then(r => r.json()).then(cart => {
              if (cart.item_count === 0 && drawer.open) {
                setTimeout(close, 800);
              }
            });
          });
        })
        .catch(() => {
          if (status) status.textContent = drawer.dataset.msgError;
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;

    root.querySelectorAll('[data-qty]').forEach((wrapper) => {
      const input = wrapper.querySelector('input');
      if (!input) return;

      wrapper.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-qty-action]');
        if (!button) return;

        const step = Number(input.step || 1);
        const min = input.min === '' ? null : Number(input.min);
        const max = input.max === '' ? null : Number(input.max);
        const current = Number(input.value || 0);
        const action = button.dataset.qtyAction;

        let next = current;
        if (action === 'increase') next += step;
        if (action === 'decrease') next -= step;

        if (min !== null && next < min) next = min;
        if (max !== null && next > max) next = max;

        input.value = next;
      });
    });

    const textarea = root.querySelector('[data-gift-message]');
    if (textarea) {
      const counter = root.querySelector('[data-gift-current]');

      const update = () => {
        if (counter) counter.textContent = textarea.value.length;
        textarea.style.height = 'auto';
        textarea.style.height = Math.min(textarea.scrollHeight, 96) + 'px';
      };

      textarea.addEventListener('input', update);
      update();
    }

    // ── Cross-sell AJAX add ──
    root.querySelectorAll('[data-cross-sell-add]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = '...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
          });

          if (!res.ok) throw new Error('Add failed');

          btn.setAttribute('data-added', '');
          btn.textContent = 'Added \u2713';

          // Update cart count in header
          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = cartData.item_count;
          });

          // Reload page after brief delay to refresh cross-sell, totals, progress bar
          setTimeout(() => { window.location.reload(); }, 1500);
        } catch (err) {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('aria-label')?.split('\u2014')[0]?.trim() || '+ Add';
        }
      });
    });

    // ── "See one more" toggle ──
    const moreBtn = root.querySelector('[data-cross-sell-more]');
    if (moreBtn) {
      const hiddenCards = root.querySelectorAll('.cart-cross-sell__card:nth-child(n+3)');
      if (hiddenCards.length > 0) {
        moreBtn.hidden = false;
        moreBtn.addEventListener('click', () => {
          hiddenCards.forEach((c) => c.classList.add('cart-cross-sell__card--visible'));
          moreBtn.hidden = true;
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggle = document.querySelector('.header__menu-toggle');
  const nav = document.getElementById('header-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      nav.classList.toggle('header__nav--open');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tsField = document.getElementById('help-contact-ts');
    if (tsField) tsField.value = Date.now();

    var form = document.getElementById('help-contact-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var loaded = parseInt(tsField && tsField.value, 10);
        if (!loaded || Date.now() - loaded < 3000) {
          e.preventDefault();
          return;
        }
      });
    }

    var params = new URLSearchParams(window.location.search);
    var subject = params.get('subject');
    var product = params.get('product');
    var productUrl = params.get('product_url');

    if (subject) {
      var select = document.getElementById('help-contact-subject');
      if (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === subject) {
            select.selectedIndex = i;
            break;
          }
        }
      }
    }

    if (product) {
      var textarea = document.getElementById('help-contact-message');
      if (textarea) {
        var line = 'Hi! I\'m interested in a custom version of ' + product;
        if (productUrl && /^\/(?:products|collections)\//.test(productUrl)) {
          line += ' (' + window.location.origin + productUrl + ')';
        }
        line += '.\n\n';
        textarea.value = line;
      }
    }

    if (subject || product) {
      var form = document.getElementById('contact');
      if (form) {
        form.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const dialog = document.querySelector('.newsletter-popup');
    if (!dialog) return;

    const STORAGE_KEY = 'newsletter_popup_dismissed';
    const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

    function isDismissed() {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return false;
      try {
        const { timestamp } = JSON.parse(stored);
        if (Date.now() - timestamp > TTL_MS) {
          localStorage.removeItem(STORAGE_KEY);
          return false;
        }
        return true;
      } catch {
        return false;
      }
    }

    function dismiss() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ timestamp: Date.now() }));
    }

    if (isDismissed()) return;

    const closeBtn = dialog.querySelector('[data-popup-close]');
    const form = dialog.querySelector('form');
    const formContent = dialog.querySelector('[data-popup-form]');
    const successContent = dialog.querySelector('[data-popup-success]');

    function open() {
      dialog.showModal();
      requestAnimationFrame(() => {
        dialog.classList.add('newsletter-popup--open');
      });
    }

    function close() {
      dialog.classList.remove('newsletter-popup--open');
      const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
      setTimeout(() => { if (dialog.open) dialog.close(); }, duration);
    }

    setTimeout(open, 10000);

    closeBtn.addEventListener('click', () => {
      dismiss();
      close();
    });

    // Close on backdrop click
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dismiss();
        close();
      }
    });

    // Close on Esc (native dialog handles this, but we need the animation)
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        dismiss();
        close();
      }
    });

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();

        const formData = new FormData(form);
        fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        }).then(() => {
          dismiss();
          formContent.hidden = true;
          successContent.hidden = false;
          setTimeout(close, 3000);
        }).catch(() => {
          form.submit();
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  const galleryRoots = document.querySelectorAll('[data-pdp-gallery]');
  galleryRoots.forEach((gallery) => {
    const heroImage = gallery.querySelector('[data-gallery-hero]');
    const heroButton = gallery.querySelector('.pdp-gallery__hero');
    const thumbButtons = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const openButtons = Array.from(gallery.querySelectorAll('[data-gallery-open]'));
    const lightbox = gallery.querySelector('[data-gallery-lightbox]');
    const lightboxDialog = gallery.querySelector('.pdp-lightbox__dialog');
    const lightboxImage = gallery.querySelector('[data-gallery-lightbox-image]');
    const lightboxThumbButtons = Array.from(gallery.querySelectorAll('[data-gallery-lightbox-thumb]'));
    const previousButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-counter]');

    if (!heroImage || !lightbox || !lightboxDialog || !lightboxImage) {
      return;
    }

    const heroVideoSlots = Array.from(gallery.querySelectorAll('[data-gallery-hero-video]'));
    const lightboxVideoSlots = Array.from(gallery.querySelectorAll('[data-gallery-lightbox-video]'));
    const heroVideoMap = {};
    heroVideoSlots.forEach((slot) => {
      const idx = Number.parseInt(slot.dataset.mediaIndex, 10);
      if (!Number.isNaN(idx)) heroVideoMap[idx] = slot;
    });
    const lightboxVideoMap = {};
    lightboxVideoSlots.forEach((slot) => {
      const idx = Number.parseInt(slot.dataset.mediaIndex, 10);
      if (!Number.isNaN(idx)) lightboxVideoMap[idx] = slot;
    });

    [].concat(heroVideoSlots, lightboxVideoSlots).forEach((slot) => {
      const video = slot.querySelector('video');
      if (video) {
        video.setAttribute('controlslist', 'nodownload');
        video.setAttribute('oncontextmenu', 'return false;');
      }
    });

    const pauseSlot = (slot) => {
      if (!slot) return;
      const video = slot.querySelector('video');
      if (video) {
        try { video.pause(); } catch (e) { /* ignore */ }
      }
      const iframe = slot.querySelector('iframe');
      if (iframe && iframe.src) {
        iframe.src = iframe.src;
      }
    };

    const pauseAllVideos = () => {
      heroVideoSlots.forEach(pauseSlot);
      lightboxVideoSlots.forEach(pauseSlot);
    };

    const applyVideoSlotVisibility = (slotMap, activeIndex) => {
      Object.keys(slotMap).forEach((key) => {
        const slot = slotMap[key];
        const isTarget = Number.parseInt(key, 10) === activeIndex;
        if (isTarget) {
          slot.hidden = false;
        } else {
          if (!slot.hidden) pauseSlot(slot);
          slot.hidden = true;
        }
      });
    };

    let items = thumbButtons
      .map((button) => ({
        src: button.dataset.src,
        lightboxSrc: button.dataset.lightboxSrc || button.dataset.src,
        alt: button.dataset.alt || '',
        width: button.dataset.width,
        height: button.dataset.height,
        mediaType: button.dataset.mediaType || 'image'
      }))
      .filter((item) => item.src);

    if (!items.length) {
      items = [
        {
          src: heroImage.currentSrc || heroImage.src,
          lightboxSrc: heroImage.dataset.lightboxSrc || heroImage.currentSrc || heroImage.src,
          alt: heroImage.alt || '',
          width: heroImage.getAttribute('width'),
          height: heroImage.getAttribute('height'),
          mediaType: 'image'
        }
      ];
    }

    const isVideoItem = (item) => !!item && (item.mediaType === 'video' || item.mediaType === 'external_video');

    const clampIndex = (value) => {
      const parsed = Number.parseInt(value, 10);
      if (Number.isNaN(parsed)) {
        return 0;
      }
      if (parsed < 0) {
        return 0;
      }
      if (parsed > items.length - 1) {
        return items.length - 1;
      }
      return parsed;
    };

    const setImage = (imageElement, item, useLightboxSource) => {
      imageElement.removeAttribute('srcset');
      imageElement.src = useLightboxSource ? item.lightboxSrc : item.src;
      imageElement.alt = item.alt;
      if (item.width) {
        imageElement.width = Number.parseInt(item.width, 10);
      }
      if (item.height) {
        imageElement.height = Number.parseInt(item.height, 10);
      }
    };

    const updateActiveState = (buttons, activeIndex) => {
      buttons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    let index = clampIndex(thumbButtons.find((button) => button.classList.contains('is-active'))?.dataset.index || '0');
    let isOpen = false;
    let isZoomed = false;
    let lastFocusedElement = null;
    const originalBodyOverflow = document.body.style.overflow;

    // ── Mobile touch state ──
    const imageWrap = gallery.querySelector('.pdp-lightbox__image-wrap');
    const mobileQuery = window.matchMedia('(max-width: 860px)');
    let isMobile = mobileQuery.matches;
    mobileQuery.addEventListener('change', (e) => { isMobile = e.matches; });
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let touchStartX = 0;
    let touchStartY = 0;
    let swipeStartTime = 0;
    let isSwiping = false;
    let isSwipeLocked = false;
    let isAnimating = false;

    // Zoom transform state (translate-based, origin always 0 0)
    let zoomScale = 1;
    let zoomTx = 0;
    let zoomTy = 0;

    // Pinch gesture start snapshot
    let pinchStartDist = 0;
    let pinchStartScale = 1;
    let pinchStartTx = 0;
    let pinchStartTy = 0;
    let pinchStartFocalX = 0;
    let pinchStartFocalY = 0;

    // Pan gesture start snapshot
    let panStartFingerX = 0;
    let panStartFingerY = 0;
    let panStartTx = 0;
    let panStartTy = 0;

    const getDistance = (t1, t2) => Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
    const getMidpoint = (t1, t2) => ({
      x: (t1.clientX + t2.clientX) / 2,
      y: (t1.clientY + t2.clientY) / 2,
    });

    const applyZoom = () => {
      lightboxImage.style.transformOrigin = '0 0';
      lightboxImage.style.transform = `translate(${zoomTx}px, ${zoomTy}px) scale(${zoomScale})`;
    };

    const clampPan = () => {
      if (zoomScale <= 1) { zoomTx = 0; zoomTy = 0; return; }
      const imgW = lightboxImage.offsetWidth;
      const imgH = lightboxImage.offsetHeight;
      zoomTx = Math.min(0, Math.max(imgW * (1 - zoomScale), zoomTx));
      zoomTy = Math.min(0, Math.max(imgH * (1 - zoomScale), zoomTy));
    };

    const resetZoom = () => {
      isZoomed = false;
      zoomScale = 1;
      zoomTx = 0;
      zoomTy = 0;
      pinchStartDist = 0;
      lightboxImage.classList.remove('is-zoomed', 'is-touching');
      if (isMobile) {
        lightboxImage.style.transformOrigin = '0 0';
        lightboxImage.style.transform = 'translate(0px, 0px) scale(1)';
      } else {
        lightboxImage.style.transform = 'scale(1)';
        lightboxImage.style.transformOrigin = '50% 50%';
      }
      if (imageWrap) {
        imageWrap.classList.remove('is-zoomed-active');
      }
    };

    const updateZoomOrigin = (event) => {
      const rect = lightboxImage.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      lightboxImage.style.transformOrigin = `${x}% ${y}%`;
    };

    const scrollThumbIntoView = () => {
      const activeThumb = lightboxThumbButtons[index];
      if (activeThumb) {
        activeThumb.scrollIntoView({
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    };

    const render = (options = {}) => {
      const item = items[index];
      const itemIsVideo = isVideoItem(item);

      setImage(heroImage, item, false);
      setImage(lightboxImage, item, true);

      applyVideoSlotVisibility(heroVideoMap, itemIsVideo ? index : -1);
      applyVideoSlotVisibility(lightboxVideoMap, itemIsVideo ? index : -1);

      if (itemIsVideo) {
        heroImage.hidden = true;
        lightboxImage.hidden = true;
        if (heroButton) heroButton.classList.add('pdp-gallery__hero--video-active');
        if (imageWrap) imageWrap.hidden = true;
      } else {
        heroImage.hidden = false;
        lightboxImage.hidden = false;
        if (heroButton) heroButton.classList.remove('pdp-gallery__hero--video-active');
        if (imageWrap) imageWrap.hidden = false;
      }

      if (counter) {
        counter.textContent = `${index + 1} / ${items.length}`;
      }
      if (!options.skipThumbs) {
        updateActiveState(thumbButtons, index);
        updateActiveState(lightboxThumbButtons, index);
        scrollThumbIntoView();
      }
    };

    const getFocusableElements = () => {
      return Array.from(lightboxDialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    };

    const trapFocus = (event) => {
      const focusable = getFocusableElements();
      if (!focusable.length) {
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const goTo = (nextIndex, direction) => {
      const resolvedIndex = nextIndex > items.length - 1
        ? 0
        : nextIndex < 0
          ? items.length - 1
          : nextIndex;

      pauseAllVideos();

      const currentIsVideo = isVideoItem(items[index]);
      const nextIsVideo = isVideoItem(items[resolvedIndex]);

      if (!isMobile || prefersReducedMotion.matches || !imageWrap || currentIsVideo || nextIsVideo) {
        index = resolvedIndex;
        resetZoom();
        render();
        if (imageWrap) {
          imageWrap.style.transform = 'translateX(0)';
        }
        return;
      }

      if (isAnimating) return;
      isAnimating = true;
      resetZoom();

      const slideDir = direction === 'prev' ? 1 : -1;

      imageWrap.classList.remove('is-swiping');
      imageWrap.style.transform = `translateX(${slideDir * 100}%)`;

      const slideIn = () => {
        imageWrap.classList.add('is-swiping');
        imageWrap.style.transform = `translateX(${slideDir * -100}%)`;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            imageWrap.classList.remove('is-swiping');
            imageWrap.style.transform = 'translateX(0)';

            const onSlideIn = () => {
              imageWrap.removeEventListener('transitionend', onSlideIn);
              isAnimating = false;
              updateActiveState(thumbButtons, index);
              updateActiveState(lightboxThumbButtons, index);
              scrollThumbIntoView();
            };
            imageWrap.addEventListener('transitionend', onSlideIn, { once: true });

            setTimeout(() => { isAnimating = false; }, 400);
          });
        });
      };

      let slideInCalled = false;
      const safeSlideIn = () => {
        if (slideInCalled) return;
        slideInCalled = true;
        slideIn();
      };

      const onSlideOut = () => {
        imageWrap.removeEventListener('transitionend', onSlideOut);
        index = resolvedIndex;
        render({ skipThumbs: true });

        // Wait for new image to load before sliding in
        if (lightboxImage.complete && lightboxImage.naturalWidth > 0) {
          safeSlideIn();
        } else {
          lightboxImage.addEventListener('load', safeSlideIn, { once: true });
          setTimeout(safeSlideIn, 2000);
        }
      };
      imageWrap.addEventListener('transitionend', onSlideOut, { once: true });

      setTimeout(() => {
        if (isAnimating) {
          imageWrap.removeEventListener('transitionend', onSlideOut);
          index = resolvedIndex;
          render();
          imageWrap.classList.remove('is-swiping');
          imageWrap.style.transform = 'translateX(0)';
          isAnimating = false;
        }
      }, 2500);
    };

    const setPageInert = (inert) => {
      const lightboxAncestor = lightbox.closest('body > *');
      const siblings = Array.from(document.body.children).filter(
        (el) => el !== lightboxAncestor && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE'
      );
      siblings.forEach((el) => {
        if (inert) {
          el.setAttribute('inert', '');
        } else {
          el.removeAttribute('inert');
        }
      });
    };

    const closeLightbox = () => {
      if (!isOpen) {
        return;
      }
      isOpen = false;
      lightbox.hidden = true;
      resetZoom();
      pauseAllVideos();
      if (imageWrap) {
        imageWrap.style.transform = 'translateX(0)';
        imageWrap.classList.remove('is-swiping');
      }
      isAnimating = false;
      document.body.style.overflow = originalBodyOverflow;
      document.removeEventListener('keydown', handleLightboxKeys);
      setPageInert(false);
      if (lastFocusedElement instanceof HTMLElement) {
        lastFocusedElement.focus();
      }
    };

    const openLightbox = (trigger) => {
      if (isOpen) {
        return;
      }
      isOpen = true;
      lastFocusedElement = trigger instanceof HTMLElement ? trigger : document.activeElement;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      setPageInert(true);
      resetZoom();
      render();
      // Preload all gallery images at lightbox resolution for instant swipe
      items.forEach((item) => {
        const preload = new Image();
        preload.src = item.lightboxSrc;
      });
      requestAnimationFrame(() => {
        lightboxDialog.focus();
      });
      document.addEventListener('keydown', handleLightboxKeys);
    };

    const handleLightboxKeys = (event) => {
      if (!isOpen) {
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
        return;
      }
      if (event.key === 'Tab') {
        trapFocus(event);
      }
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => openLightbox(button));
    });

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        index = clampIndex(button.dataset.index);
        render();
      });
    });

    lightboxThumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        index = clampIndex(button.dataset.index);
        resetZoom();
        render();
      });
    });

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        goTo(index - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goTo(index + 1);
      });
    }

    lightbox.addEventListener('click', (event) => {
      if (event.target.closest('[data-gallery-close]')) {
        closeLightbox();
      }
    });

    const lightboxMain = gallery.querySelector('.pdp-lightbox__main');
    if (lightboxMain) {
      lightboxMain.addEventListener('click', (event) => {
        if (event.target === lightboxMain) {
          closeLightbox();
        }
      });
    }

    lightboxImage.addEventListener('click', (event) => {
      if (isMobile) return;
      if (isZoomed) {
        resetZoom();
      } else {
        isZoomed = true;
        updateZoomOrigin(event);
        lightboxImage.style.transform = 'scale(2.5)';
        lightboxImage.classList.add('is-zoomed');
      }
    });

    lightboxImage.addEventListener('mousemove', (event) => {
      if (!isZoomed) {
        return;
      }
      updateZoomOrigin(event);
    });

    lightboxImage.addEventListener('mouseleave', () => {
      resetZoom();
    });

    lightboxImage.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    // ── Mobile touch handlers ──
    if (imageWrap && 'ontouchstart' in window) {
      const onTouchStart = (e) => {
        if (!isMobile || !isOpen || isAnimating) return;
        if (isVideoItem(items[index])) return;

        if (e.touches.length === 2) {
          lightboxImage.classList.add('is-touching');
          isSwiping = false;
          isSwipeLocked = false;
          imageWrap.classList.remove('is-swiping');

          const t1 = e.touches[0], t2 = e.touches[1];
          pinchStartDist = getDistance(t1, t2);
          pinchStartScale = zoomScale;
          pinchStartTx = zoomTx;
          pinchStartTy = zoomTy;
          const mid = getMidpoint(t1, t2);
          const rect = imageWrap.getBoundingClientRect();
          pinchStartFocalX = mid.x - rect.left;
          pinchStartFocalY = mid.y - rect.top;
          return;
        }

        if (e.touches.length === 1) {
          lightboxImage.classList.add('is-touching');
          const t = e.touches[0];
          touchStartX = t.clientX;
          touchStartY = t.clientY;
          swipeStartTime = Date.now();
          isSwiping = false;
          isSwipeLocked = false;

          if (zoomScale > 1.1) {
            panStartFingerX = t.clientX;
            panStartFingerY = t.clientY;
            panStartTx = zoomTx;
            panStartTy = zoomTy;
          }
        }
      };

      const onTouchMove = (e) => {
        if (!isMobile || !isOpen || isAnimating) return;
        if (isVideoItem(items[index])) return;

        // ── Pinch ──
        if (e.touches.length === 2) {
          e.preventDefault();
          const t1 = e.touches[0], t2 = e.touches[1];
          const dist = getDistance(t1, t2);
          zoomScale = Math.min(4, Math.max(1, pinchStartScale * (dist / pinchStartDist)));

          // Keep the image point under the initial focal at the current focal
          const mid = getMidpoint(t1, t2);
          const rect = imageWrap.getBoundingClientRect();
          const focalX = mid.x - rect.left;
          const focalY = mid.y - rect.top;
          const ratio = zoomScale / pinchStartScale;
          zoomTx = focalX - (pinchStartFocalX - pinchStartTx) * ratio;
          zoomTy = focalY - (pinchStartFocalY - pinchStartTy) * ratio;

          clampPan();
          applyZoom();

          if (zoomScale > 1.1) {
            isZoomed = true;
            lightboxImage.classList.add('is-zoomed');
            imageWrap.classList.add('is-zoomed-active');
          }
          return;
        }

        if (e.touches.length !== 1) return;
        const t = e.touches[0];
        const dx = t.clientX - touchStartX;
        const dy = t.clientY - touchStartY;

        // ── Pan when zoomed ──
        if (zoomScale > 1.1) {
          e.preventDefault();
          const rawTx = panStartTx + (t.clientX - panStartFingerX);
          const rawTy = panStartTy + (t.clientY - panStartFingerY);

          const imgW = lightboxImage.offsetWidth;
          const imgH = lightboxImage.offsetHeight;
          const minTx = imgW * (1 - zoomScale);
          const minTy = imgH * (1 - zoomScale);
          zoomTx = Math.min(0, Math.max(minTx, rawTx));
          zoomTy = Math.min(0, Math.max(minTy, rawTy));
          applyZoom();

          // At horizontal edge + overshoot → reset zoom, start swipe
          const overshoot = Math.abs(rawTx - zoomTx);
          if (overshoot > 30) {
            resetZoom();
            imageWrap.style.transform = 'translateX(0)';
            touchStartX = t.clientX;
            touchStartY = t.clientY;
            swipeStartTime = Date.now();
            isSwiping = false;
            isSwipeLocked = false;
          }
          return;
        }

        // ── Swipe direction lock ──
        if (!isSwipeLocked) {
          if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
            isSwipeLocked = true;
            isSwiping = Math.abs(dx) >= Math.abs(dy);
          }
          return;
        }

        if (!isSwiping) return;

        e.preventDefault();
        imageWrap.classList.add('is-swiping');

        // Rubber-band at edges
        let translateX = dx;
        const isFirst = index === 0 && dx > 0;
        const isLast = index === items.length - 1 && dx < 0;
        if (isFirst || isLast) {
          translateX = dx * 0.3;
        }
        imageWrap.style.transform = `translateX(${translateX}px)`;
      };

      const onTouchEnd = (e) => {
        if (!isMobile || !isOpen) return;
        if (isVideoItem(items[index])) return;
        lightboxImage.classList.remove('is-touching');

        // ── Pinch end ──
        if (pinchStartDist > 0 && e.touches.length < 2) {
          pinchStartDist = 0;
          if (zoomScale <= 1.1) {
            // Quick zoom-out → snap back so user can swipe
            resetZoom();
            imageWrap.style.transform = 'translateX(0)';
          } else if (e.touches.length === 1) {
            // Transition from pinch to pan with remaining finger
            const remaining = e.touches[0];
            panStartFingerX = remaining.clientX;
            panStartFingerY = remaining.clientY;
            panStartTx = zoomTx;
            panStartTy = zoomTy;
          }
          return;
        }

        // ── Swipe end ──
        if (isSwiping) {
          imageWrap.classList.remove('is-swiping');
          const dx = (e.changedTouches[0]?.clientX || 0) - touchStartX;
          const elapsed = Date.now() - swipeStartTime;
          const velocity = Math.abs(dx) / elapsed;
          const threshold = 50;

          if ((Math.abs(dx) > threshold || velocity > 0.3) && items.length > 1) {
            if (dx > 0) {
              goTo(index - 1, 'prev');
            } else {
              goTo(index + 1, 'next');
            }
          } else {
            imageWrap.style.transform = 'translateX(0)';
          }
        }

        isSwiping = false;
        isSwipeLocked = false;
      };

      imageWrap.addEventListener('touchstart', onTouchStart, { passive: true });
      imageWrap.addEventListener('touchmove', onTouchMove, { passive: false });
      imageWrap.addEventListener('touchend', onTouchEnd, { passive: true });
      imageWrap.addEventListener('touchcancel', onTouchEnd, { passive: true });
    }

    render();

    gallery.goToIndex = (idx) => { index = clampIndex(idx); render(); };
  });

  // ── Variant switching ──
  const variantSelect = document.getElementById('pdp-variant-select');
  if (variantSelect) {
    const galleryEl = document.querySelector('[data-pdp-gallery]');
    const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));
    const mediaMap = {};
    thumbs.forEach((thumb) => {
      const mid = thumb.dataset.mediaId;
      if (mid) mediaMap[mid] = Number.parseInt(thumb.dataset.index, 10);
    });

    const priceEl = document.getElementById('pdp-price');
    const priceAnnounce = document.getElementById('pdp-price-announce');
    const addBtn = document.getElementById('pdp-add-btn');
    const stickyPrice = document.querySelector('.pdp__sticky-price');
    const stickyBtn = document.getElementById('pdp-sticky-btn');

    const applyVariant = (option) => {
      const imageId = option.dataset.imageId;
      if (imageId && galleryEl && galleryEl.goToIndex != null && mediaMap[imageId] != null) {
        galleryEl.goToIndex(mediaMap[imageId]);
      }

      const price = option.dataset.price;
      if (priceEl) priceEl.textContent = price;
      if (priceAnnounce) priceAnnounce.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;

      const available = option.dataset.available === 'true';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Basket' : 'Sold Out';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? 'Add to Basket' : 'Sold Out';
      }

      const url = new URL(window.location);
      url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url);
    };

    variantSelect.addEventListener('change', () => {
      variantSelect.classList.remove('pdp__variant-select--invalid');
      applyVariant(variantSelect.options[variantSelect.selectedIndex]);
    });

    variantSelect.addEventListener('invalid', () => {
      variantSelect.classList.add('pdp__variant-select--invalid');
    });

    // On load: only apply if a real variant is selected (not placeholder)
    const initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption && initialOption.value) {
      applyVariant(initialOption);
    }
  }

  // ── Quantity buttons ──
  const qtyBtns = document.querySelectorAll('.pdp__qty-btn');
  qtyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector('.pdp__qty-input');
      let val = parseInt(input.value) || 1;
      const max = parseInt(input.max) || 10;
      if (btn.dataset.action === 'increase' && val < max) val++;
      else if (btn.dataset.action === 'decrease' && val > 1) val--;
      input.value = val;
    });
  });

  // ── ATC with AJAX + cart drawer (Section 2.6) ──
  const addBtn = document.getElementById('pdp-add-btn');
  const form = document.getElementById('pdp-form');
  const atcStatus = document.getElementById('pdp-atc-status');
  if (form && addBtn) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const origText = addBtn.textContent.trim();
      addBtn.disabled = true;

      const formData = new FormData(form);
      const body = {
        items: [{
          id: parseInt(formData.get('id')),
          quantity: parseInt(formData.get('quantity')) || 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(r => {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(() => {
          addBtn.textContent = '\u2713 Added!';
          addBtn.style.backgroundColor = 'var(--color-success)';
          if (atcStatus) atcStatus.textContent = 'Item added to basket';
          window.dispatchEvent(new CustomEvent('cart:added'));
          setTimeout(() => {
            addBtn.textContent = origText;
            addBtn.style.backgroundColor = '';
            addBtn.disabled = false;
            if (atcStatus) atcStatus.textContent = '';
          }, 3000);
        })
        .catch(r => {
          if (r && r.status === 422) {
            addBtn.textContent = 'Sold out';
            if (atcStatus) atcStatus.textContent = 'This item is sold out';
          } else {
            window.location = '/cart';
            return;
          }
          addBtn.disabled = false;
          setTimeout(() => {
            addBtn.textContent = origText;
            addBtn.style.backgroundColor = '';
            if (atcStatus) atcStatus.textContent = '';
          }, 3000);
        });
    });
  }

  // ── Sticky mobile ATC bar (Section 2.7) ──
  const stickyBar = document.getElementById('pdp-sticky-bar');
  const addRow = document.getElementById('pdp-add-row');
  if (stickyBar && addRow) {
    const stickyBtn = document.getElementById('pdp-sticky-btn');
    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = !entry.isIntersecting;
        stickyBar.classList.toggle('pdp__sticky-bar--visible', visible);
        stickyBar.setAttribute('aria-hidden', !visible);
        if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
      },
      { threshold: 0 }
    );
    observer.observe(addRow);

    // Sticky bar button submits the main form
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', () => {
        form.requestSubmit();
      });
    }
  }


  } catch(e) { console.error(e); }
})();
})();
